<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
              <vs-button @click="goBack" color="danger" type="border" icon="keyboard_backspace">Back</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="9" vs-sm="4" vs-xs="12">
              <h3>Edit Email Template</h3>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
            </vs-col>
          </vs-row>
          <template v-if="editTemplate">

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="name" v-model="emailTemplateDescription.name" v-validate="'required'"
                data-vv-as="Name" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('name')">{{ errors.first("name") }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="description" v-model="emailTemplateDescription.description"
                data-vv-as="Fields Description" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('description')">{{
                errors.first("description")
            }}</span>
          </div>
          <div class="m-5  warning">
  <p><strong>Note : </strong> The text inside single curly braces { } will be recognized as variable. </p>
</div>

<div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Subject:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-textarea v-model="emailTemplateDescription.template_subject" />

            </div>
          
          </div>

              <ckeditor id="editor" v-model="emailTemplateDescription.template_text" :config="editorConfig"></ckeditor>


          <div class="text-center">
            <div class="p-4">
              <vs-button class="mb-2" @click.prevent="submitForm">Submit</vs-button>

            </div>
            <div>

            </div>
          </div>
          </template>
          <template v-if="assignVariables">




<div class="vx-row mb-6">

  <vs-row vs-w="12" class="mb-5">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
              <h6>Search</h6>
            </vs-col>
            <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
              <CampaignAutocomplete :key="companySearchComponentKey" class="searchbox" :list="searchCampaign"
      :searchOn="'campaign'" @event-name="handleChildEvent"></CampaignAutocomplete>
            </vs-col>

            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
            </vs-col>


          </vs-row>

          

          



</div>

<template v-if="selected_campaign">
              <div class="text-left m-10">

                <div class="warning pb-10">
  <p><strong>Note : </strong> </p>
  <p> * Please select campaign to assign fields to a variables..</p>
  <p> * Choosing multiple fields will be created as table on the email.</p>
  <p> * Choose recipient field for email user.</p>
  <p> * Choose campaign_link field for campaign link.</p>

</div>

  <!-- {{ savedVariables }} -->


  <vs-row vs-w="12" class="mb-5" v-for="v, index in savedVariables">
            <vs-col vs-type="flex"  vs-lg="1" vs-sm="4" vs-xs="12">
              <h6>{{ v.variable }}</h6>
            </vs-col>
            <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
              <v-select multiple :closeOnSelect="false" :options="acc_con_columns" :key="index"
        v-model="variable_fields[index]" />
            </vs-col>
          </vs-row>


                 <div class="text- p-5">

                  <span class="text-danger text-sm">{{
                    field_variable_eror_msg
                  }}</span>
                </div>

                <div class="text-left">
                  <vs-button @click.prevent="updateVariable">Update Variable</vs-button>

                </div>



          
          <div>
            </div>

</div>


</template>



</template>


        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import vSelect from "vue-select";
// import "quill/dist/quill.core.css";
// import "quill/dist/quill.snow.css";
// import "quill/dist/quill.bubble.css";
// import { quillEditor } from "vue-quill-editor";
export default {
  beforeMount() {
  },
  data() {
    return {
      opp_columns: [],
      field_variable_eror_msg:null,
      previous_template_text : null,
      acc_con_columns: [],
      selected_campaign: [],
      companySearchComponentKey: 0,
      account_columns: [],
      contact_columns: [],
      csv_table_columns: [],
      editor: null,
      variable_fields: [],
      savedVariables: [],
      assignVariables: false,
      editTemplate:true,
      
      editorConfig: {
          extraPlugins : 'justify,colorbutton',
            // The configuration of the editor.
        },
      emailTemplateDescription:[],
      emailTemplateId:null,
      selected_campaign: null,
      selected_campaign_id: null,
      campaign_required: null,
      companySearchComponentKey: 0,
      please_choose_grades: null,
      selected: [],
      abilities: null,
      emailTemplateDescription: {
        name: null,
        description: null,
        template_text: null,
        user_id: null,
        variables : [],
      },
    };
  },
  components: {
    "v-select": vSelect,
    CampaignAutocomplete,
    // quillEditor
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }

  },
  mounted() {
    this.emailTemplateId = this.$route.params.emailTemplateId;
    this.fetchEmailTemplate()
    
  },
  watch: {
  },
  methods: {
    handleChildEvent() {
      let self = this;
      let result = moduleCampaignManagement.state.campaign.datas
      self.selected_campaign = result[0]
      console.log(self.selected_campaign)
      self.fetchClientViewAccountFields()



    },
    searchCampaign(inputValue) {
      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchCampaign", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name: data[property].campaign_name + '  -   ' + data[property].campaign_code,
                    type: "campaign"
                  });
                }
              }


              const key = 'id';

const newMappedArray = [...new Map(mappedArray.map(item => [item[key], item])).values()];              
  



  return newMappedArray;
            }
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    
    fetchClientViewAccountFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign.id;
      this.$store
        .dispatch(
          "campaignsManagement/fetchClientViewAccountFields",
          selected_campaign_id
        )
        .then(response => {
          this.account_columns = response.data;

          let acc_columns = []
          this.account_columns.forEach(e => acc_columns.push(e.column_name))
          this.account_columns = acc_columns

          self.fetchClientViewOpportunityFields()


        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    fetchClientViewOpportunityFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign.id;
      this.$store
        .dispatch(
          "campaignsManagement/fetchClientViewOpportunityFields",
          selected_campaign_id
        )
        .then(response => {
          this.opp_columns = response.data;

          let opp_columns = []
          this.opp_columns.forEach(e => opp_columns.push(e.column_name))
          this.opp_columns = opp_columns

          self.fetchClientViewContactFields()


        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    fetchClientViewContactFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign.id;
      this.$store
        .dispatch(
          "campaignsManagement/fetchClientViewContactFields",
          selected_campaign_id
        )
        .then(response => {
          this.contact_columns = response.data;
          let con_columns = []
          this.contact_columns.forEach(e => con_columns.push(e.column_name))
          this.contact_columns = con_columns
          this.acc_con_columns = [...this.account_columns, ...this.contact_columns , ...this.opp_columns];

          this.acc_con_columns.push('sales_developer')
          this.acc_con_columns.push('recipient')
          this.acc_con_columns.push('campaign_link')

          self.acc_con_columns =  self.acc_con_columns.filter((item,index) => self.acc_con_columns.indexOf(item) === index);



        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    updateVariable() {
      var self = this;
      let v_f = []

      console.log("dfsdfdfsf" , self.savedVariables)
      self.savedVariables.forEach(function (e, i) {

        self.variable_fields.forEach(function (ele, index) {

          if (i == index) {
            v_f.push({ variable: e, values: ele })
          }
        })


      })


      if (v_f.length == 0 || self.savedVariables.length != v_f.length) {
        self.field_variable_eror_msg = "Please select fields for the template variables"
        return false
      } else {

        this.$store.dispatch("campaignsManagement/addEmailTemplateVariable", v_f)
        .then(res => {
          this.$vs.notify({
            color: "success",
            title: "Email Template",
            text: res.data.message
          });
          this.$router.go(0);
        })
        .catch(err => {
          console.log(err);

          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });

      }




      console.log(v_f)




    },
    fetchEmailTemplate() {
    this.$store
        .dispatch("campaignsManagement/fetchEmailTemplate", this.emailTemplateId)
        .then(res => {
          this.emailTemplateDescription = res.data;
          this.previous_template_text = this.emailTemplateDescription.template_text

        })
        .catch(err => {
          console.error(err);
        });
    },
    goBack: function () {
      this.$router.go(-1);
    },
    submitForm() {
      let self = this


      self.$validator.validateAll().then(result => {
        if (result) {
          self.updateEmailTemplate();
        }
      });
    },
    setVariables(template_text){
      var found = [],          // an array to collect the strings that are found
      rxp = /{+([^}]+)}+/g,
      str = template_text,
      curMatch;

      while( curMatch = rxp.exec( str ) ) {
          found.push( curMatch[1] );
      }
      console.log( "sdfsdfsdf" , found );


      this.emailTemplateDescription.variables = found

    },
    updateEmailTemplate() {

      this.setVariables(this.emailTemplateDescription.template_text)

      this.emailTemplateDescription.user_id = this.user_id

      this.$store.dispatch("campaignsManagement/updateEmailTemplate", this.emailTemplateDescription)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Email Template",
              text: res.data.message
            });
          } else {

            this.savedVariables = res.data
            this.editTemplate = false
            this.assignVariables = true
           
          }
        })
        .catch(err => {
          console.log(err);

          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}

.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}

.ql-class {
  height: 400px;

}
</style>
